<template>
  <div class='wrap' :class="{wrapshow:showFlag}">
    <div class='close' @click='closeFlag'></div>
    <div v-if="color[colorIdx]" class='picwrap' :style='{backgroundImage:"linear-gradient(to bottom, #"+color[colorIdx].s_color+", #"+color[colorIdx].e_color+")"}'>
      <img class='opic' :src='originpic' />
    </div>
     <div class='colorgroupWrap' v-show="needAll === 1"></div>
    <div class='colorgroup' v-show="needAll !== 1">
    <div v-for="item in color"
         :key="item.color_name"
         class='bal'
         :class='{bsg:item.s_color === "ffffff" && item.e_color === "ffffff"}'
         :style='{backgroundImage:"linear-gradient(to bottom, #"+item.s_color+", #"+item.e_color+")"}'></div>
    </div>
    <div class='oprwrap'>
    <div class='otitle'>增值服务</div>
    <div class='optionwrap'>
        <div class='op'
             :class="{activeop:priceIdx === 0}"
             @click='selpidx(0)'
             v-show="closeKey">
        <img v-show='priceIdx === 0' class='gou'  :src="require('@/assets/skins/'+platformInfo.skin+'/pay_add_selecled@3x.png')" />
          换正装￥{{price.single_price_fm/100}}
        </div>
        <div class='op'
             :class="{activeop:priceIdx === 1}"
             @click='selpidx(1)'
        >
        <img v-show='priceIdx === 1' class='gou'  :src="require('@/assets/skins/'+platformInfo.skin+'/pay_add_selecled@3x.png')" />
          无￥{{price.single_price_pg/100}}
        </div>
    </div>
    </div>
    <div class='oprwrap' v-show="color.length !== 1">
    <div class='otitle'>背景颜色</div>
    <div class='optionwrap'>
        <div class='op'
             :class="{activeop:needAll === 0}"
             @click='selall(0)'>
        <img v-show="needAll === 0" class='gou' :src="require('@/assets/skins/'+platformInfo.skin+'/pay_add_selecled@3x.png')" />
          全部背景色
        </div>
        <div class='op'
             :class="{activeop:needAll === 1}"
             @click='selall(1)'>
        <img v-show="needAll === 1" class='gou' :src="require('@/assets/skins/'+platformInfo.skin+'/pay_add_selecled@3x.png')" />
          选中背景色
        </div>
    </div>
    </div>
    <div class='btnWrap'>
        <div @click='gopay' class="btn" :class="`bg_${platformInfo.skin}`">
            <img class="tj" src='./imgs/btn_price_tag@3x.png' />
            <div class="yuanjia" v-show="color.length > 1 && needAll === 0">
              原价￥{{yuanjia}}
            </div>
              ￥{{needmoney}} 保存电子照
        </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import { setTimeout } from 'timers';
export default {
  props: {
    showFlag: {
      type: Boolean,
      default: false
    },
    originpic: {
      type: String,
      default: ""
    },
    color: {
      type: Array,
      default: []
    },
    colorIdx: {
      type: Number,
      default: 0
    },
    closeKey: {
      type: String,
      value: '123'
    },
    beautyFlag: {
      type: Boolean,
      default: true
    }
  },
  watch:{
    closeKey(newval) {
      this.priceIdx = newval ? 0 : 1;
    }
  },
  computed: {
    ...mapState(['processedPhoto','platformInfo', 'actiBol']),
    yuanjia() {
      return this.priceArr.length > 0 ? this.color.length*this.priceArr[this.priceIdx][1]/100 : 0;
    },
    allidx() {
      return this.color.length > 1?this.needAll:1
    },
    needmoney() {
      return this.priceArr.length > 0 ? this.priceArr[this.priceIdx][this.allidx]/100 : 0;
    }
  },
  data() {
    return {
      price: {},
      priceArr: [],
      priceIdx: 1,
      needAll: 0
    }
  },
  activated() {
    if(!this.actiBol){
      return;
    }
    this.gotprice().then(res => {
      let data = res.data;
      let price = {};
      for (let item in data) {
        if (item !== "code") {
          price[item] = data[item];
        }
      }
      let priceArr = [[price.multiple_price_fm, price.single_price_fm], [price.multiple_price_pg, price.single_price_pg]];
      this.price = price;
      this.priceArr = priceArr;
    })
    this.needAll = 0;
  },
  created() {
    
  },
  methods: {
    ...mapActions(["gotprice"]),
    closeFlag() {
      this.$emit("closeflag",false);
    },
    selpidx(idx) {
      let picinfo = this.processedPhoto.picinfo;
      this.priceIdx = idx;
      let showUrl = idx === 0 ? picinfo.wm_url[0] : this.beautyFlag ? picinfo.wm_url_beauty[0] : picinfo.wm_url_no[0];
      this.$emit("changezhengwu", showUrl);
    },
    selall(idx) {
      this.needAll = idx;
    },
    gopay() {
      let colors = this.needAll === 0 ? this.color : [this.color[this.colorIdx]];
      let fee = this.priceIdx;
      let picinfo = this.processedPhoto.picinfo;
      let algo_fileuuid = this.priceIdx === 0 ? picinfo.algo_fileuuid : this.beautyFlag ? picinfo.algo_fileuuid_beauty : picinfo.algo_fileuuid_no;
      let data = {
        colors,
        fee,
        algo_fileuuid
      } // detail对象，提供给事件监听函数
      this.$emit('elepay', data);
    }
  }
}
</script>

<style scoped>
.wrap{
  width:100%;
  background-color: white;
  position:absolute;
  bottom:0;
  left:0;
  box-sizing: border-box;
  padding-top: 0.3rem;
  text-align: center;
  transform: translateY(100%);
  -webkit-transform: translateY(100%);
  transition: all 0.2s linear;
  -webkit-transition: all 0.2s linear;
}
.wrapshow{
  transform: translateY(0);
  -webkit-transform: translateY(0);
}
.close{
  width: 0.23rem;
  height: 0.23rem;
  position:absolute;
  transform: rotate(45deg);
  right:0.15rem;
  top:0.15rem;
}
.close::after{
  content:'';
  display: block;
  width:100%;
  height:0.025rem;
  background-color: #BFBFBF;
  position:absolute;
  top:50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  left:0;
}
.close::before{
  content:'';
  display: block;
  width:0.025rem;
  height:100%;
  background-color: #BFBFBF;
  position:absolute;
  left:50%;
   transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
  top:0;
}
.btnWrap{
  margin-top: 0.26rem;
  box-shadow: 0 0 0.26rem rgba(211,211,211,0.5);
  padding:0.08rem 0.1rem;
}
.btn{
  height: 0.45rem;
  display: flex;
  position: relative;
  display: -webkit-flex;
  font-size: 0.16rem;
  align-items: center;
  color:white;
  border-radius: 0.225rem;
  /* padding-left: 182rpx; */
  justify-content: center;
  /* background-image:linear-gradient(to bottom, #3B99FF,#3D97FD); */
  /* background-image:-webkit-linear-gradient(to bottom, #3B99FF,#3D97FD); */
}
.btn:hover {
  opacity: 0.8;
}
.yuanjia {
  font-size: 0.11rem;
  opacity: 0.6;
  text-decoration: line-through;
  margin-right: 0.03rem;
}
.tj {
  width: 0.6rem;
  height: 0.45rem;
  position: absolute;
  left: 0;
  top: 0;
}
.picwrap {
  width: 1.7rem;
  margin: 0 auto;
}
.opic {
  width: 100%;
  display: block;
}
.colorgroupWrap {
  margin-top: 0.12rem;
  height: 0.16rem;
}
.colorgroup {
  margin-top: 0.12rem;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
}
.bal {
  width: 0.16rem;
  height: 0.16rem;
  border-radius: 50%;
  flex-shrink: 0;
  box-sizing: border-box;
  margin-right: 0.12rem;
}
.bsg {
  border: 0.02rem solid #E5E5E5 !important;
}
.oprwrap {
  margin-top: 0.2rem;
  padding: 0 0.25rem;
}
.otitle {
  font-size: 0.15rem;
  color: #666666;
  margin-bottom: 0.12rem;
  text-align: left;
}
.gou {
  width: 0.2rem;
  height: 0.2rem;
  position: absolute;
  top: -2px;
  right: -2px;
}
.optionwrap {
  display: flex;
  display: -webkit-flex;
}
.op {
  position: relative;
  padding: 0.1rem 0.2rem;
  border: 2px solid #E5E5E5;
  border-radius: 0.04rem;
  margin-right: 0.15rem;
  font-size: 0.14rem;
  color: #999999;
  box-sizing: border-box;
}
.activeop {
  background-color: #FFF9F0;
  color: #F5A623;
  border-color: #F5A623;
}
</style>